import { ViewHook } from "phoenix_live_view";

class SortableTable extends ViewHook {
  private sortableColumns?: NodeListOf<HTMLElement>;
  private itemEventListeners?: Map<HTMLElement, (event: MouseEvent) => void>;

  private sortEventName?: string;

  mounted() {
    this.itemEventListeners = new Map();

    this.onSortColumnClick = this.onSortColumnClick.bind(this);

    this.sortEventName = this.el.dataset.sortEvent;
    if (!this.sortEventName) {
      throw new Error("SortableTable: sortEvent is required");
    }

    this.sortableColumns = this.el.querySelectorAll("th[data-sort-by]");

    this.sortableColumns.forEach((column) => {
      const eventHandler = (event: MouseEvent) => {
        this.onSortColumnClick(event, column);
      };

      column.addEventListener("click", eventHandler);

      this.itemEventListeners?.set(column, eventHandler);
    });
  }

  destroyed() {
    this.itemEventListeners?.forEach((eventHandler, column) => {
      column.removeEventListener("click", eventHandler);
    });

    this.itemEventListeners?.clear();
    this.sortableColumns = undefined;
  }

  updated() {
    // Re-mounting the hook so that any new/removed columns have their event listeners
    // re-attached.
    this.destroyed();
    this.mounted();
  }

  private onSortColumnClick(event: MouseEvent, column: HTMLElement) {
    const { sortBy, sortDir, defaultSortDir } = column.dataset;

    const isSorted = "sorted" in column.dataset;

    const newSortDir = isSorted ? (sortDir === "asc" ? "desc" : "asc") : defaultSortDir;

    if (!isSorted) {
      this.clearSortedFlags();
    }

    column.dataset.sorted = "";
    column.dataset.sortDir = newSortDir;

    this.el.dataset.loading = "";

    void this.pushEvent(this.sortEventName!, {
      sort_by: sortBy,
      sort_dir: newSortDir,
    });
  }

  private clearSortedFlags() {
    this.sortableColumns?.forEach((column) => {
      delete column.dataset.sorted;
    });
  }
}

export default SortableTable;
